/** Convert LaTeX delimiters before Markdown can interpret equation lines as headings. */
export const normalizeMathDelimiters = (text: string): string =>
  text
    // Callback replacements preserve literal $$; replacement strings collapse $$ to $.
    // Display delimiters must be on separate lines for remark-math block parsing.
    .replace(/\\\[([\s\S]*?)\\\]/g, (_, formula: string) => `\n\n$$\n${formula.trim()}\n$$\n\n`)
    .replace(/\\\(([\s\S]*?)\\\)/g, (_, formula: string) => `$${formula}$`);
